/* Unicode Constants */
export const BLANK = '\u00a0';
export const DEG_F = '\u2109';
export const DEG_C = '\u2103';
